module.exports = __webpack_public_path__ + "static/media/dodgem.a6e72962.jpg";